import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';
import { CustomSnackbarService } from 'src/app/ui/components/custom-snackbar/custom-snackbar-service';

import { AuthService } from '../../../../data/services/auth.service';
import { MustMatch } from '../../../../data/utils/must-match-validator.utils';
import { Credentials } from './../../../../data/models/enum/credentials.enum';
import { UserUtil } from './../../../../data/utils/user.utils';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent {
  loading: boolean = false;
  email: string = '';

  passwordMinLengthErrorMsg = 'Senha deve conter ao menos 6 caracteres'
  passwordRequiredErrorMsg = 'Informe a nova senha';
  passwordMatchErrorMsg = 'As senhas devem ser iguais';

  fgForm: FormGroup = this.fb.group(
    {
      code: ['', [Validators.required, Validators.minLength(6)]],
      password: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6)]],
    },
    {
      validator: MustMatch('password', 'confirmPassword'),
    }
  );

  constructor(
    private readonly fb: FormBuilder,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private snackbarService: CustomSnackbarService,
    private readonly authService: AuthService,
    private readonly userUtil: UserUtil
  ) {
    this.route.params.subscribe((params: Params) => {
      this.email = params['email'];
    });
  }

  get f() {
    return this.fgForm.controls;
  }

  ngOnInit() {}

  async onSubmit() {
    if (this.fgForm.invalid) {
      return;
    }

    this.loading = true;
    const newPassword = this.fgForm.value.password;
    const confirmationCode = this.fgForm.value.code;

    try {
      await this.authService
        .confirmForgotPassword(this.email, confirmationCode, newPassword)
        .toPromise();
      this.snackbarService.open(
        'Senha redefinida com sucesso',
        SnackbarTypeEnum.SUCCESS,
        'center',
        'bottom'
      );
      this.login(this.email, newPassword);
    } catch (ex: any) {
      this.loading = false;

      const invalidCode: boolean = ex?.status === 400 && ex?.error?.data?.type === Credentials.CODE_MISMATCH_EXCEPTION;

      if (invalidCode) {
        this.snackbarService.open(
          'Código informado inválido ou não encontrado',
          SnackbarTypeEnum.ERROR,
          'center',
          'bottom'
        );
      } else {
        this.snackbarService.open(
          'Falha ao redefinir senha',
          SnackbarTypeEnum.ERROR,
          'center',
          'bottom'
        );
      }
    }
  }

  async resendCode() {
    try {
      await this.authService.forgotPassword(this.email).toPromise();
      this.snackbarService.open(
        'Código enviado com sucesso',
        SnackbarTypeEnum.SUCCESS,
        'center',
        'bottom'
      );
    } catch (error) {
      this.snackbarService.open(
        'E-mail inválido ou não encontrado',
        SnackbarTypeEnum.ERROR,
        'center',
        'bottom'
      );
    }
  }

  private async login(email: string, password: string) {
    try {
      await this.authService.login(email, password);
      this.routeTo();
      this.loading = false;
      this.resetPasswordValidator()
    } catch (error) {
      console.log(error);
      this.snackbarService.open(
        'Credenciais inválidas',
        SnackbarTypeEnum.ERROR,
        'center',
        'bottom'
      );
      this.loading = false;
    }
  }

  private routeTo(): void {
    let route = 'news-list';
    
    if (this.userUtil.isFuncionarioProfile()) {
      route = 'users';
    }

    this.router.navigate([route]);
    this.loading = false;
  }

  private resetPasswordValidator() {
    this.fgForm.controls['password'].setValidators([Validators.required]);
  }
}
